const s = ":host{display:block;width:100%}.sl-textarea{display:block;width:100%;min-height:60px;padding:var(--sl-spacing-2) var(--sl-spacing-3);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);line-height:1.5;color:hsl(var(--sl-hsl-foreground));background-color:hsl(var(--sl-hsl-input));border:1px solid hsl(var(--sl-hsl-border));border-radius:var(--sl-radius-md);box-shadow:var(--sl-shadow-sm);outline:none;transition:border-color var(--sl-transition-fast),box-shadow var(--sl-transition-fast);resize:vertical;box-sizing:border-box}.sl-textarea::placeholder{color:hsl(var(--sl-hsl-muted-foreground))}.sl-textarea:hover:not(:disabled):not(:read-only){border-color:hsl(var(--sl-hsl-primary-200))}.sl-textarea:focus{border-color:hsl(var(--sl-hsl-primary));box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-textarea:disabled{cursor:not-allowed;opacity:0.5}.sl-textarea:read-only{background-color:hsl(var(--sl-hsl-muted));cursor:default}.sl-textarea--error{border-color:hsl(var(--sl-hsl-destructive))}.sl-textarea--error:hover:not(:disabled):not(:read-only){border-color:hsl(var(--sl-hsl-destructive))}.sl-textarea--error:focus{border-color:hsl(var(--sl-hsl-destructive));box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-destructive))}.sl-textarea__feedback{display:block;font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-xs);line-height:1.4;margin-top:var(--sl-spacing-1);color:hsl(var(--sl-hsl-muted-foreground))}.sl-textarea__feedback--error{color:hsl(var(--sl-hsl-destructive))}.sl-textarea__feedback[hidden]{display:none}@media (max-width:768px){.sl-textarea{font-size:16px}}";
let a = 0;
class i extends HTMLElement {
  constructor() {
    super(), this._textarea = null, this._feedback = null, this._handleInputBound = this._handleInput.bind(this), this._handleChangeBound = this._handleChange.bind(this), this._handleFocusBound = this._handleFocus.bind(this), this._handleBlurBound = this._handleBlur.bind(this), this._shadow = this.attachShadow({ mode: "open" }), this._feedbackId = `sl-textarea-feedback-${++a}`, this._render();
  }
  static get observedAttributes() {
    return ["value", "placeholder", "disabled", "readonly", "rows", "name", "required", "error", "error-message", "helper-text"];
  }
  connectedCallback() {
    this._bindEvents();
  }
  disconnectedCallback() {
    this._textarea && (this._textarea.removeEventListener("input", this._handleInputBound), this._textarea.removeEventListener("change", this._handleChangeBound), this._textarea.removeEventListener("focus", this._handleFocusBound), this._textarea.removeEventListener("blur", this._handleBlurBound));
  }
  attributeChangedCallback(e, t, r) {
    t !== r && (this._textarea && e === "value" ? this._textarea.value = r || "" : this._updateTextarea());
  }
  get value() {
    return this._textarea ? this._textarea.value : this.getAttribute("value") || "";
  }
  set value(e) {
    this.setAttribute("value", e), this._textarea && (this._textarea.value = e);
  }
  get placeholder() {
    return this.getAttribute("placeholder") || "";
  }
  set placeholder(e) {
    this.setAttribute("placeholder", e);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get readonly() {
    return this.hasAttribute("readonly");
  }
  set readonly(e) {
    e ? this.setAttribute("readonly", "") : this.removeAttribute("readonly");
  }
  get rows() {
    return parseInt(this.getAttribute("rows") || "3", 10);
  }
  set rows(e) {
    this.setAttribute("rows", String(e));
  }
  get name() {
    return this.getAttribute("name");
  }
  set name(e) {
    e ? this.setAttribute("name", e) : this.removeAttribute("name");
  }
  get required() {
    return this.hasAttribute("required");
  }
  set required(e) {
    e ? this.setAttribute("required", "") : this.removeAttribute("required");
  }
  get error() {
    return this.hasAttribute("error");
  }
  set error(e) {
    e ? this.setAttribute("error", "") : this.removeAttribute("error");
  }
  get errorMessage() {
    return this.getAttribute("error-message") || "";
  }
  set errorMessage(e) {
    e ? this.setAttribute("error-message", e) : this.removeAttribute("error-message");
  }
  get helperText() {
    return this.getAttribute("helper-text") || "";
  }
  set helperText(e) {
    e ? this.setAttribute("helper-text", e) : this.removeAttribute("helper-text");
  }
  _handleInput(e) {
    const t = e.target;
    this.dispatchEvent(
      new CustomEvent("input", {
        bubbles: !0,
        composed: !0,
        detail: { value: t.value }
      })
    ), this.dispatchEvent(
      new CustomEvent("update:value", {
        bubbles: !0,
        composed: !0,
        detail: { value: t.value }
      })
    );
  }
  _handleChange(e) {
    const t = e.target;
    this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: { value: t.value }
      })
    );
  }
  _handleFocus(e) {
    this.dispatchEvent(
      new CustomEvent("focus", {
        bubbles: !0,
        composed: !0,
        detail: { originalEvent: e }
      })
    );
  }
  _handleBlur(e) {
    this.dispatchEvent(
      new CustomEvent("blur", {
        bubbles: !0,
        composed: !0,
        detail: { originalEvent: e }
      })
    );
  }
  _bindEvents() {
    this._textarea && (this._textarea.addEventListener("input", this._handleInputBound), this._textarea.addEventListener("change", this._handleChangeBound), this._textarea.addEventListener("focus", this._handleFocusBound), this._textarea.addEventListener("blur", this._handleBlurBound));
  }
  _updateTextarea() {
    this._textarea && (this._textarea.placeholder = this.placeholder, this._textarea.rows = this.rows, this._textarea.disabled = this.disabled, this._textarea.readOnly = this.readonly, this.name ? this._textarea.name = this.name : this._textarea.removeAttribute("name"), this._textarea.required = this.required, this._textarea.className = this._getTextareaClasses(), this.error ? this._textarea.setAttribute("aria-invalid", "true") : this._textarea.removeAttribute("aria-invalid"), this.required ? this._textarea.setAttribute("aria-required", "true") : this._textarea.removeAttribute("aria-required"), this._updateFeedback());
  }
  _updateFeedback() {
    if (!this._feedback || !this._textarea) return;
    const e = this.error && this.errorMessage.length > 0, t = !e && this.helperText.length > 0, r = e ? this.errorMessage : t ? this.helperText : "";
    this._feedback.textContent = r, this._feedback.className = e ? "sl-textarea__feedback sl-textarea__feedback--error" : "sl-textarea__feedback", r ? (this._feedback.removeAttribute("hidden"), this._textarea.setAttribute("aria-describedby", this._feedbackId)) : (this._feedback.setAttribute("hidden", ""), this._textarea.removeAttribute("aria-describedby"));
  }
  _getTextareaClasses() {
    const e = ["sl-textarea"];
    return this.error && e.push("sl-textarea--error"), e.join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${s}</style>
      <textarea
        class="${this._getTextareaClasses()}"
        placeholder="${this.placeholder}"
        rows="${this.rows}"
        ${this.disabled ? "disabled" : ""}
        ${this.readonly ? "readonly" : ""}
        ${this.name ? `name="${this.name}"` : ""}
        ${this.required ? "required" : ""}
      >${this.getAttribute("value") || ""}</textarea>
      <span class="sl-textarea__feedback" id="${this._feedbackId}" hidden></span>
    `, this._textarea = this._shadow.querySelector("textarea"), this._feedback = this._shadow.querySelector(".sl-textarea__feedback"), this._updateTextarea();
  }
  focus() {
    this._textarea?.focus();
  }
  blur() {
    this._textarea?.blur();
  }
  select() {
    this._textarea?.select();
  }
}
typeof customElements < "u" && !customElements.get("sl-textarea") && customElements.define("sl-textarea", i);
export {
  i as SlTextareaElement
};
//# sourceMappingURL=sl-textarea.js.map
